import { useEffect } from 'react'

/**
 * In the /subscribe flow we want to reset scroll position on mobile
 * after moving between steps.
 * We use Tailwind's `lg` breakpoint (1024px). "Mobile" is < 1024px.
 */
export const useMobileSubscribeStepScrollTop = () => {
	useEffect(() => {
		if (window.matchMedia('(max-width: 1023px)').matches) {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
		}
	}, [])
}
